import React, { useState } from "react";
import { API_BASE } from "../lib/api";

/**
 * Displays a photo by pointing an <img> tag directly at the backend
 * /files/ route, which 307-redirects to a presigned S3 URL. Using a
 * plain <img> (not an XHR/blob fetch) avoids CORS entirely and lets the
 * browser follow the redirect and cache the image. Auth travels via the
 * vs_token cookie, with ?auth= as a fallback for cross-subdomain cases.
 */
export default function AuthImage({ path, alt = "", className = "", testId }) {
  const [err, setErr] = useState(false);

  if (!path || err) {
    return (
      <div className={`bg-stone-100 flex items-center justify-center text-stone-400 text-xs ${className}`}>
        No image
      </div>
    );
  }

  const token = (() => {
    try { return localStorage.getItem("vs_token") || ""; } catch { return ""; }
  })();
  const sep = token ? `?auth=${encodeURIComponent(token)}` : "";
  const url = `${API_BASE}/files/${path}${sep}`;

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      data-testid={testId}
      loading="lazy"
      onError={() => setErr(true)}
    />
  );
}
